import { render } from "./HomeButtonGroup.vue?vue&type=template&id=3b843d4a&scoped=true"
const script = {}

import "./HomeButtonGroup.vue?vue&type=style&index=0&id=3b843d4a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b843d4a"]])

export default __exports__